import {Component, Mixins} from 'vue-property-decorator';
import ClaimColumns from '@/components/claim/mixins/ClaimColumns';
import {difference, head} from 'lodash';

interface MemberGroup{
  memberGroupName: string
  memberGroupNo: number
}

const mergedRows = ['platformType', 'mallNo', 'orderRegisterType', 'reservation', 'memberGroupInfoJson', 'recommenderId', 'payType', 'orderNo', 'ordererName', 'ordererContact1', 'memberNo'] as const;

// 클레임 item-table에 공통적으로 사용되는 메서드들을 모아놓은 mixin
@Component
export default class ClaimGrid extends Mixins(ClaimColumns) {
  protected showMemberGroup: boolean = false;
  protected memberGroup: MemberGroup[] = [];
  protected exchangeHelpData = {
    id: 'memberGroup',
    width: 400,
    maxHeight: 300,
    title: 'ORDER_LIST_GRIDS_MEMBER_GROUP_LAYER_TITLE',
    hasConfirmBtn: false
  };

  protected reSearchClaim(){
    (this.$refs.ClaimContentTop as any).onSearch('1');
  }

  protected mounted(){
    (window as any).reSearchClaim = this.reSearchClaim
    $('body').on('click', '.member-group-name-grid', $.proxy(this.clickMemberGroupNameInGrid, this));
  }
  protected destroyed(): void {
    (window as any).reSearchClaim = undefined
    $('body').off('click', '.member-group-name-grid', $.proxy(this.clickMemberGroupNameInGrid, this));
  }

  private clickMemberGroupNameInGrid(e: any): void {
    this.memberGroup = [];
    this.memberGroup = JSON.parse(
      $(e.target)
        .data('json')
        .replace(/\\\"/g, '"')
    );
    this.showMemberGroup = true;
  }


  // TODO: ST쪽 코드, 이쁘게 리팩토링
  /**
   * claim array의 각 claim 객체에서 depths가 있는 데이터를 key1값에 넣고, key1 프로퍼티들을 상위 객체에 삽입하여 다시 삽입하여 array를 return하는 함수
   * 덤으로 tui-grid에 쓰일 _attribute와 rowspan 프로퍼티도 넣어준다. (근데 넣어주기만 한다. 값을 빈값으로 넣는다.)
   * @param arr claims
   * @param key1 options
   */
  public claimFormatterList(arr: any, key1: any): any {
    let arry: any = [];
    if (arr && arr.length > 0) { // claims가 빈값이 아니면
      arr.forEach((item: any): any => { // 각 claims 순회 하면서, item: claim
        item[key1].forEach((item1: any): any => { // 각 클레임의 options를 순회한다. item1: option
          let obj: any = {}; // obj: options 안의 값들을 뽑아내 tuigrid에 맞게 컬럼들을 변환시킨 객체
          Object.keys(item).forEach((name: any): any => { // claim의 key값들을 순회하면서 name: keyValue
            if (name !== key1) { // 프로퍼니 네임(키값)이 options가 아닌 프로퍼티는 그대로 obj에 복사한다.
              obj[name] = item[name];
            }
          });
          Object.keys(item1).forEach((name1: any): any => { // option의 키값을 순회하면서 name1: option 프로퍼티 키값
            obj[name1] = item1[name1]; // obj.name1 에 option.name1(프로퍼티 키값)의 값을 대입한다
          });
          if (item.options.length <= 1) { // options 2개 이상이면, _isMerge라는 플래그 값 true
            this.$set(obj, '_isMerge', false);
          } else {
            this.$set(obj, '_isMerge', true);
          }
          this.$set(obj, '_attributes', {}); // tuigrid에 사용될 _attributes를 set한다.
          this.$set(obj['_attributes'], 'rowSpan', {}); // tuigrid에 사용될 _attributes.rowSpan을 set한다.
          arry.push(obj); // arry에 push한다.
        });
      });
      return arry;
    }
  }

  /**
   *
   * @param 행들을 merge 하고자 하는 row 리스트 (claims)
   * @param bigRow merge행이 많은 필드명 리스트
   * @param bigGroupFlag merge행 필드 중 임의로 하나
   */
  public claimMeargeRow(arr: any, bigRow: any, bigGroupFlag: string): any {
    if (arr && arr.length === 0) {
      return;
    }
    let bigGroup: any = []; // claim.bigGroupFlag 값을 담는 배열(대체 무슨용도인데)
    let newArry: any = [];
    arr.forEach((item: any): void => { // 클레임리스트를 순회하면서, arr: claims, item: claim
      if (bigGroup.indexOf(item[bigGroupFlag]) < 0) { // merge하고자 하는 필드명 리스트에 claim.bigGroupFlag 없다면 -> 이 제어문 왜 필요한거지
        bigGroup.push(item[bigGroupFlag]); // claim.bigGroupFlag를 bigGroup에 담는다.
      }
    });
    bigGroup.forEach((bigItem: any): void => { // bigGroup을 순회하면서 bigItem: claim.bigGroupFlag
      let nums: any = arr.filter((item: any): any => { // claims안에 bigItem 과 내용이 같
        return bigItem === item[bigGroupFlag];
      });
      let firstRow = true;
      arr.forEach((item: any): void => {
        if (bigItem === item[bigGroupFlag]) {
          if (firstRow && nums.length > 1 && item._isMerge) {
            let rowSpanTag = bigRow;
            this.addRowSpan(rowSpanTag, item, nums.length);
            firstRow = false;
          }
          newArry.push(item);
        }
      });
    });
    return newArry;
  }

  public addRowSpan(arr: any, tag: any, length: number): void {
    if (arr.length === 0) {
      return;
    }
    arr.forEach((items: any): any => {
      if (length > 1) {
        this.$set(tag['_attributes']['rowSpan'], items, length);
      }
    });
  }
	public setCommunicateFailBgColor(orderListContent, gridRef) {
		if (!orderListContent.length) return;
		const columnNames = difference(Object.keys(head(orderListContent)), mergedRows);
		
		orderListContent.forEach(order => {
			if (order.communicateFail) {
				setTimeout((): void => {
					(gridRef as any).addRowClassName(order.rowKey, 'fail-order');
				}, 100);
			}
			if (order.freeGiftConditionBrokenType !== null && order.freeGiftConditionBrokenType === 'CLAIM_DONE') {
				this.$nextTick(() => {
					columnNames.forEach(name => gridRef.addCellClassName(order.rowKey, name, 'red'));
				})
			}
			
		});
	}
}
